module.exports = __webpack_public_path__ + "static/img/detratores-recorrentes.04ba7d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/detratores-recorrentes.png
// module id = OhT1
// module chunks = 1